namespace Matrix.Data {
    export class ListColumns {
        static columnsKey = 'Data.List';
    }
}
